<template>
  <div class="consult-leads">
    <div class="card">
      <div class="card-header">
        <el-breadcrumb>
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>咨询运营</el-breadcrumb-item>
          <el-breadcrumb-item>咨询线索</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button type="primary" icon="el-icon-refresh" circle @click="refresh"></el-button>
      </div>

      <div class="consult-leads__filters">
        <el-select v-model="filters.status" clearable placeholder="线索状态">
          <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input v-model="filters.phone" clearable placeholder="手机号" class="consult-leads__input"></el-input>
        <el-input v-model="filters.tag" clearable placeholder="AI 标签" class="consult-leads__input"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="search">筛选</el-button>
      </div>

      <div class="consult-leads__summary">共 {{ total }} 条咨询线索</div>
      <el-table :data="leads" style="width: 100%" v-loading="loading">
        <el-table-column prop="child_name" label="孩子"></el-table-column>
        <el-table-column label="性别" width="80">
          <template slot-scope="scope">{{ sexText(scope.row.child_sex) }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="140"></el-table-column>
        <el-table-column prop="source" label="来源" width="120"></el-table-column>
        <el-table-column prop="last_contact_time" label="最近咨询" width="180"></el-table-column>
        <el-table-column label="状态" width="145">
          <template slot-scope="scope">
            <el-select :value="scope.row.status" size="mini" @change="updateStatus(scope.row, $event)">
              <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="consult-leads__pagination">
        <el-pagination background :page-size="pageSize" layout="prev, pager, next" :total="total" @current-change="changePage"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'consult-leads',
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      leads: [],
      filters: { status: '', phone: '', tag: '' },
      statuses: [
        { label: '新线索', value: 'new' },
        { label: '已联系', value: 'contacted' },
        { label: '已合格', value: 'qualified' },
        { label: '已转人工', value: 'handed-off' },
        { label: '已关闭', value: 'closed' }
      ]
    }
  },
  created() {
    this.fetchLeads()
  },
  methods: {
    async fetchLeads() {
      this.loading = true
      try {
        const query = Object.assign({ page: this.page }, this.filters)
        const params = Object.keys(query).filter(key => query[key] !== '').map(key => `${key}=${encodeURIComponent(query[key])}`).join('&')
        const res = await this.$request(`consult-lead?${params}`)
        if (res && res.error_code === 10000) {
          this.leads = res.data.data || []
          this.page = res.data.current_page || this.page
          this.pageSize = res.data.per_page || this.pageSize
          this.total = res.data.total || 0
        }
      } finally {
        this.loading = false
      }
    },
    async updateStatus(lead, status) {
      const previous = lead.status
      lead.status = status
      const res = await this.$request(`consult-lead/${lead.id}/status`, { status }, 'patch')
      if (!res || res.error_code !== 10000) {
        lead.status = previous
        this.$message.error((res && res.msg) || '状态更新失败')
      }
    },
    search() {
      this.page = 1
      this.fetchLeads()
    },
    refresh() {
      this.page = 1
      this.filters = { status: '', phone: '', tag: '' }
      this.fetchLeads()
    },
    changePage(page) {
      this.page = page
      this.fetchLeads()
    },
    openDetail(id) {
      this.$router.push({ path: '/consult-detail', query: { id } })
    },
    sexText(sex) {
      return Number(sex) === 1 ? '男' : Number(sex) === 2 ? '女' : '-'
    }
  }
}
</script>

<style scoped>
.consult-leads__filters { display: flex; align-items: center; gap: 10px; margin: 20px 0; }
.consult-leads__input { width: 180px; }
.consult-leads__summary { margin: 16px 0; color: #6a7d74; }
.consult-leads__pagination { margin-top: 20px; text-align: right; }
</style>
